/**
 * Builds a Google Maps LatLngBounds from an array of points.
 *
 * @param {Array<{ lat: number, lng: number }>} points - Array of points with lat and lng.
 * @returns {google.maps.LatLngBounds | null} Bounds encompassing all valid points, or null if none.
 */
const getBoundsFromPoints = (points) => {
  if (!Array.isArray(points)) return null;

  const valid = points.filter(
    (p) => p && typeof p.lat === 'number' && typeof p.lng === 'number',
  );
  if (
    !valid.length ||
    typeof window?.google?.maps?.LatLngBounds !== 'function'
  ) {
    return null;
  }

  const bounds = new window.google.maps.LatLngBounds();
  valid.forEach((p) => bounds.extend({ lat: p.lat, lng: p.lng }));
  return bounds;
};

export default getBoundsFromPoints;
